import * as React from 'react';
import { LinkProps } from 'react-router-dom';
import { useGetNotificationBellCount } from './hooks/notificationQueries';
import { Colors } from '../../components/Shared/Style/colors';
import { Icon } from '../../components/Icon/Icon';
import { NotificationCount } from '../../components/NotificationCount/NotificationCount';
import IconWrapper from '../../components/Icon/themed/IconWrapper';
import styled from '../../components/lib/styled';

import { style } from '../../components/Shared/Style';
import NotificationModal from './components/NotificationModal';

const StyledNotificationCount = styled(NotificationCount)({
    top: '-7px',
    right: '-7px',
    fontSize: '0.7rem',
    color: style.colors.white,
});

type Props = {
    to: LinkProps['to'];
    color?: Colors;
    size?: string;
};

export const NotificationBell: React.FC<Props> = ({ to, size }) => {
    const { data: bellCount } = useGetNotificationBellCount();
    const [isOpenModal, setIsOpenModal] = React.useState(false);
    const handleCloseModal = () => setIsOpenModal(false);
    return (
        <>
            <IconWrapper>
                <Icon.NotificationBell onClick={() => setIsOpenModal(!isOpenModal)} />
                <StyledNotificationCount counts={bellCount?.count ?? 0} color={style.colors.errors} />
            </IconWrapper>

            <NotificationModal isOpenModal={isOpenModal} handleCloseModal={handleCloseModal} to={to} size={size} />
        </>
    );
};
export default NotificationBell;
